import { render } from "./TopSearch.vue?vue&type=template&id=72eb6ec0&ts=true"
import script from "./TopSearch.vue?vue&type=script&lang=ts"
export * from "./TopSearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__